const SecondHero = () => {
  return (
    <div className="container-fluid" id="container">
      <div className="row">
        <div className="col bgimage" id="lowerhero"></div>
      </div>
    </div>
  );
};

export default SecondHero;
